module.exports = {"230605008":"杏南街道","230605009":"创业街道","230605010":"红岗街道","230605011":"八百垧街道","230605012":"银河街道","230605013":"解放街道","230605100":"杏树岗镇","230605480":"黑龙江红岗经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230605.json
// module id = 823
// module chunks = 0